import { DEFAULT_SCROLL_OBSERVER_ROOT_ID } from '../constants';
import {
  SCROLL_OBSERVER_ENTRY_ID,
  SCROLL_OBSERVER_ROOT_ID,
} from '../provider/ScrollObserverProvider/constants';

import type {
  EntryIdentifier,
  ScrollObserverEntryId,
  ScrollObserverRootContextState,
  ScrollObserverRootId,
} from '../provider/ScrollObserverProvider/types';

export const isTargetEntry = (a: EntryIdentifier, b: EntryIdentifier) => {
  return a.entryId === b.entryId && a.rootId === b.rootId;
};

export const getScrollObserverRootElement = (rootId: ScrollObserverRootId) => {
  return rootId
    ? document.querySelector<HTMLElement>(`[${SCROLL_OBSERVER_ROOT_ID}="${rootId}"]`)
    : null;
};

export const getScrollObserverEntryElement = (entryId: ScrollObserverEntryId) => {
  return document.querySelector<HTMLElement>(`[${SCROLL_OBSERVER_ENTRY_ID}="${entryId}"]`);
};

export const getThresholdByStep = (resolution: number) => {
  if (resolution <= 0) console.error('Resolution must be greater than 0');
  return Array(resolution)
    .fill(0)
    .map((_, i) => i / resolution)
    .concat(1);
};

export const defaultContextValue: ScrollObserverRootContextState = {
  rootId: DEFAULT_SCROLL_OBSERVER_ROOT_ID,
  threshold: getThresholdByStep(10),
};
